import { render, staticRenderFns } from "./ExportDispatchOrigin.vue?vue&type=template&id=a9bb37f8&scoped=true"
import script from "./ExportDispatchOrigin.vue?vue&type=script&lang=js"
export * from "./ExportDispatchOrigin.vue?vue&type=script&lang=js"
import style0 from "./ExportDispatchOrigin.vue?vue&type=style&index=0&id=a9bb37f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb37f8",
  null
  
)

export default component.exports